// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles-module--footer--1717O","linksRow":"styles-module--links-row--d1QKo","divider":"styles-module--divider--Bv8CG"};